'use strict';

import angular from 'angular';
import Gallery from './gallery.controller';

export default angular.module('bfastCaptureManagerApp.application.gallery', [])
  .controller('AppGalleryController', Gallery)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/gallery/index.js